<template>
  <div class="plan-vista">

    <!-- ── Cabecera ── -->
    <div class="header-flex">
      <div>
        <h1 class="titulo">Plan de mejoramiento y fortalecimiento</h1>
        <p v-if="proceso?.version?.nombre" class="ctx-modelo">{{ proceso.version.nombre }}</p>
        <p v-if="plan || proceso" class="subtitulo">
          <template v-if="proceso?.periodo"><b>Período:</b> {{ proceso.periodo }} &nbsp;·&nbsp;</template>
          <template v-if="proceso?.version?.nombre"><b>Versión:</b> {{ proceso.version.nombre }} &nbsp;·&nbsp;</template>
          <template v-if="plan?.programa"><b>Programa:</b> {{ plan.programa }} &nbsp;·&nbsp;</template>
          <b>Elaboración:</b> {{ formatFecha(plan?.fecha_elaboracion) }}
          <span v-if="plan" class="estado-plan">{{ plan.estado }}</span>
        </p>
      </div>
      <div class="acciones-barra">
        <button class="btn salir" @click="$router.push({ name: 'ProcesoAutoevaluacionUsuario' })">Volver</button>
        <template v-if="plan">
          <button class="btn salir" :disabled="generando" @click="generar" title="Añade características nuevas sin tocar lo diligenciado">
            Regenerar
          </button>
          <button class="btn guardar" :disabled="exportando" @click="exportar">
            {{ exportando ? 'Exportando…' : 'Exportar xlsx' }}
          </button>
        </template>
      </div>
    </div>

    <div class="divider"></div>

    <!-- ── SIN PLAN ── -->
    <div v-if="!cargando && !plan" class="sin-plan-card">
      <h2>Esta ejecución no tiene un plan registrado</h2>
      <p>Se generará automáticamente desde la matriz de fortalezas y debilidades: acciones de mejoramiento para las debilidades y de fortalecimiento para las fortalezas por consolidar, con prioridad sugerida según el grado de cumplimiento.</p>
      <button class="btn guardar" :disabled="generando" @click="generar">
        {{ generando ? 'Generando…' : 'Generar Plan' }}
      </button>
    </div>

    <!-- ── CON PLAN ── -->
    <template v-if="plan">

      <!-- Barra: filtros + botón columnas -->
      <div class="filtros-barra">
        <div class="filtros">
          <button
            v-for="f in filtros"
            :key="f.id"
            class="tab"
            :class="{ activo: filtro === f.id }"
            @click="filtro = f.id"
          >{{ f.label }} ({{ contar(f.id) }})</button>
        </div>
        <button class="btn-col-cfg" @click="abrirConfigColumnas">
          Columnas
        </button>
      </div>

      <div class="contenedor-tabla">
        <table class="lista-tabla">
          <thead>
            <tr>
              <template v-for="c in columnasOrdenadas" :key="c.key">
                <th v-if="c.visible" :class="{ 'th-extra': c.tipo === 'extra' }">{{ c.titulo }}</th>
              </template>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="a in accionesFiltradas" :key="a.id_accion">
              <template v-for="c in columnasOrdenadas" :key="c.key">
                <template v-if="c.visible">
                  <td v-if="c.tipo === 'extra'">{{ c.extraCol!.filas[String(a.id_accion)] ?? '' }}</td>
                  <td v-else-if="c.clave === 'factor'"><b>{{ a.componente?.padre?.nombre }}</b><br>{{ a.componente?.nombre }}</td>
                  <td v-else-if="c.clave === 'calificacion'" class="num">{{ a.calificacion?.toFixed(2) ?? '—' }}</td>
                  <td v-else-if="c.clave === 'tipo'"><span class="pill" :class="a.tipo === 'FORTALECIMIENTO' ? 'p-verde' : 'p-ambar'">{{ a.tipo }}</span></td>
                  <td v-else-if="c.clave === 'prioridad'"><span class="pill" :class="pillPrioridad(a.prioridad)">{{ a.prioridad ?? '—' }}</span></td>
                  <td v-else-if="c.clave === 'actividad'" class="texto">{{ a.actividad_general ?? 'Por diligenciar' }}</td>
                  <td v-else-if="c.clave === 'responsable'" class="texto">{{ a.responsable_cargo ?? '—' }}</td>
                  <td v-else-if="c.clave === 'terminacion'">{{ formatFecha(a.fecha_terminacion) }}</td>
                  <td v-else-if="c.clave === 'estado'"><span class="pill" :class="pillEstado(a.estado)">{{ a.estado.replace('_', ' ') }}</span></td>
                  <td v-else-if="c.clave === 'avance'" class="num">{{ a.avance_pct }}%</td>
                </template>
              </template>
              <td><button class="btn accion mini" @click="abrirModal(a)">Editar</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <p v-if="error" class="mensaje error">{{ error }}</p>

    <!-- ── MODAL CONFIGURAR COLUMNAS ── -->
    <div v-if="configModal" class="modal-fondo" @click.self="configModal = false">
      <div class="modal modal-config">
        <div class="cfg-header">
          <h3>Configurar columnas</h3>
          <button class="btn-cerrar" @click="configModal = false">&#x2715;</button>
        </div>

        <div class="cfg-body">

          <!-- 3 secciones con columnas ordenables -->
          <div v-for="grupo in configDraftGrupos" :key="grupo.id" class="cfg-seccion">
            <div class="cfg-seccion-titulo">{{ grupo.label }}</div>
            <div class="col-config-lista">
              <div
                v-for="(item, idx) in grupo.items" :key="item.key"
                class="col-config-fila"
                :class="{ 'col-es-extra': item.tipo === 'extra' }"
              >
                <label v-if="item.tipo === 'sistema'" class="col-toggle">
                  <input type="checkbox" v-model="draftSys(item.key).visible" />
                  <span class="toggle-label">{{ draftSys(item.key).visible ? 'Visible' : 'Oculta' }}</span>
                </label>
                <span v-else class="col-toggle-spacer"></span>

                <input
                  v-if="item.tipo === 'sistema'"
                  v-model="draftSys(item.key).titulo"
                  class="input-col-titulo"
                  :disabled="!draftSys(item.key).visible"
                  placeholder="Nombre del encabezado"
                />
                <input
                  v-else
                  v-model="draftExtra(item.key).titulo"
                  class="input-col-titulo"
                  placeholder="Nombre de la columna"
                />

                <button
                  class="btn-mover"
                  :disabled="idx === 0"
                  @click="moverEnSeccionDraft(grupo.id, item.key, -1)"
                  title="Subir"
                >↑</button>
                <button
                  class="btn-mover"
                  :disabled="idx === grupo.items.length - 1"
                  @click="moverEnSeccionDraft(grupo.id, item.key, +1)"
                  title="Bajar"
                >↓</button>

                <button v-if="item.tipo === 'extra'" class="btn-elim-col" @click="eliminarColExtra(item.key)">&#x2715;</button>
              </div>
              <p v-if="!grupo.items.length" class="sin-extra">Sin columnas en esta sección.</p>
            </div>
          </div>

          <!-- Agregar columna adicional -->
          <div class="cfg-seccion">
            <div class="cfg-seccion-titulo">Agregar columna adicional</div>
            <p class="cfg-desc">Se puede editar su valor en el modal de cada acción, en la pestaña de la sección elegida.</p>
            <div class="nueva-col-form-v2">
              <input
                v-model="nuevoTituloColExtra"
                class="input-col"
                placeholder="Nombre de la columna..."
                @keyup.enter="agregarColExtra"
              />
              <div class="seccion-radio-row">
                <span class="seccion-label">Sección:</span>
                <label v-for="sec in SECCIONES_UI" :key="sec.id" class="seccion-radio">
                  <input type="radio" v-model="nuevaColSeccion" :value="sec.id" />
                  {{ sec.label }}
                </label>
              </div>
              <div class="posicion-row">
                <span class="seccion-label">Posición:</span>
                <select v-model="nuevaColPosicion" class="select-posicion">
                  <option value="ultimo">Al final de la sección</option>
                  <option
                    v-for="item in (configDraftGrupos.find(g => g.id === nuevaColSeccion) ?? { items: [] }).items"
                    :key="item.key"
                    :value="item.key"
                  >Después de "{{ item.tipo === 'sistema' ? draftSys(item.key).titulo : draftExtra(item.key).titulo }}"</option>
                </select>
              </div>
              <button class="btn-add-col" :disabled="!nuevoTituloColExtra.trim()" @click="agregarColExtra">
                Añadir
              </button>
            </div>
          </div>

        </div>

        <div class="modal-pie">
          <button class="btn salir" @click="configModal = false">Cancelar</button>
          <button class="btn guardar" @click="aplicarConfig">Aplicar</button>
        </div>
      </div>
    </div>

    <!-- ── MODAL DE EDICIÓN ── -->
    <div v-if="modal" class="modal-fondo" @click.self="modal = null">
      <div class="modal">
        <h2 class="modal-titulo">{{ modal.componente?.padre?.nombre }} → {{ modal.componente?.nombre }}</h2>
        <p class="linea-base">Línea de base: {{ modal.linea_base }}</p>

        <div class="tabs">
          <button class="tab" :class="{ activo: pestana === 'accion' }" @click="pestana = 'accion'">Acción</button>
          <button class="tab" :class="{ activo: pestana === 'recursos' }" @click="pestana = 'recursos'">Recursos y entregables</button>
          <button class="tab" :class="{ activo: pestana === 'seguimiento' }" @click="pestana = 'seguimiento'">Seguimiento</button>
        </div>

        <div v-if="pestana === 'accion'" class="form">
          <label>Causa raíz de la acción<textarea v-model="form.causa_raiz" rows="2"></textarea></label>
          <label>Actividad general<textarea v-model="form.actividad_general" rows="2"></textarea></label>
          <label>Actividades específicas a realizar<textarea v-model="form.actividades_especificas" rows="3"></textarea></label>
          <div class="fila">
            <label>Tipo de acción
              <select v-model="form.tipo"><option>MEJORAMIENTO</option><option>FORTALECIMIENTO</option></select>
            </label>
            <label>Prioridad
              <select v-model="form.prioridad"><option>ALTA</option><option>MEDIA</option><option>BAJA</option></select>
            </label>
          </div>
          <label>Cargo del responsable de la ejecución<input v-model="form.responsable_cargo" type="text"></label>
          <div class="fila">
            <label>Fecha de inicio<input v-model="form.fecha_inicio" type="date"></label>
            <label>Fecha de terminación<input v-model="form.fecha_terminacion" type="date"></label>
          </div>
          <label>Meta<textarea v-model="form.meta" rows="2"></textarea></label>
          <template v-if="extrasDeSeccion('accion').length">
            <hr class="form-divider" />
            <label v-for="ec in extrasDeSeccion('accion')" :key="ec.id">
              {{ ec.titulo }}
              <input v-model="extraColValues[ec.id]" type="text" :placeholder="`Valor para «${ec.titulo}»`" />
            </label>
          </template>
        </div>

        <div v-if="pestana === 'recursos'" class="form">
          <fieldset><legend>Recursos</legend>
            <label class="chk"><input v-model="form.recursos!.h" type="checkbox"> Humanos</label>
            <label class="chk"><input v-model="form.recursos!.f" type="checkbox"> Físicos</label>
            <label class="chk"><input v-model="form.recursos!.t" type="checkbox"> Tecnológicos</label>
          </fieldset>
          <div class="fila">
            <label>Presupuesto proyectado<input v-model.number="form.presupuesto_proyectado" type="number" min="0"></label>
            <label>Presupuesto ejecutado<input v-model.number="form.presupuesto_ejecutado" type="number" min="0"></label>
          </div>
          <fieldset><legend>Entregable</legend>
            <label v-for="e in tiposEntregable" :key="e.clave" class="chk">
              <input v-model="(form.entregables as any)[e.clave]" type="checkbox"> {{ e.label }}
            </label>
            <label v-if="form.entregables?.otro">¿Cuál?<input v-model="form.entregables!.cual" type="text"></label>
          </fieldset>
          <label>Fuente de verificación (enlace o referencia documental)<input v-model="form.fuente_verificacion" type="text" placeholder="Enlace, ruta de red o referencia al documento"></label>
          <label>¿Qué falta por cumplir?<textarea v-model="form.por_cumplir" rows="2" placeholder="Describa lo que queda pendiente de esta acción"></textarea></label>
          <template v-if="extrasDeSeccion('recursos').length">
            <hr class="form-divider" />
            <label v-for="ec in extrasDeSeccion('recursos')" :key="ec.id">
              {{ ec.titulo }}
              <input v-model="extraColValues[ec.id]" type="text" :placeholder="`Valor para «${ec.titulo}»`" />
            </label>
          </template>
        </div>

        <div v-if="pestana === 'seguimiento'" class="form">
          <div class="fila">
            <label>Fecha de seguimiento<input v-model="seg.fecha_seguimiento" type="date"></label>
            <label>Estado
              <select v-model="seg.estado">
                <option value="NO_INICIADO">NO INICIADO</option>
                <option value="EN_DESARROLLO">EN DESARROLLO</option>
                <option value="CUMPLIDO">CUMPLIDO</option>
                <option value="NO_CUMPLIDO">NO CUMPLIDO</option>
                <option value="ANULADO">ANULADO</option>
              </select>
            </label>
          </div>
          <div class="fila">
            <label>% de avance<input v-model.number="seg.avance_pct" type="number" min="0" max="100"></label>
            <label>Fecha de cierre<input v-model="seg.fecha_cierre" type="date"></label>
          </div>
          <label>Observaciones<textarea v-model="seg.observaciones" rows="3"></textarea></label>
          <template v-if="extrasDeSeccion('seguimiento').length">
            <hr class="form-divider" />
            <label v-for="ec in extrasDeSeccion('seguimiento')" :key="ec.id">
              {{ ec.titulo }}
              <input v-model="extraColValues[ec.id]" type="text" :placeholder="`Valor para «${ec.titulo}»`" />
            </label>
          </template>
        </div>

        <div class="modal-pie">
          <span v-if="mensajeModal" class="mensaje" :class="{ error: mensajeModalError }">{{ mensajeModal }}</span>
          <button class="btn salir" @click="modal = null">Cerrar</button>
          <button class="btn guardar" :disabled="guardando" @click="guardarModal">{{ guardando ? 'Guardando…' : 'Guardar' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * Plan de mejoramiento y fortalecimiento.
 *
 * Acciones con responsable, fechas y avance. Las alertas C4 y C5 vigilan las
 * vencidas y las que van a vencer con avance insuficiente.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/ejecucion/:id_ejecucion/plan-mejoramiento` (PlanMejoramiento) — permiso `planes.ver`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

import { ref, computed, onMounted, reactive, watch } from 'vue'
import { useRoute } from 'vue-router'
import {
  generarPlanService, getPlanService, actualizarAccionService,
  registrarSeguimientoService, getPlanExportService,
  type PlanMejoramiento, type AccionMejora
} from '@/services/PlanMejoramientoService'
import { getProcesoByIdService } from '@/services/ProcesoAutoevaluacionService'
import type { Proceso } from '@/interfaces/ProcesoAutoevaluacion'
import { exportarPlanInstitucional } from '@/utils/planMejoramientoExport'

const route = useRoute()
const idEjecucion = Number(route.params.id_ejecucion)

// ── Plan state ────────────────────────────────────────────────────────────────

const cargando   = ref(true)
const generando  = ref(false)
const exportando = ref(false)
const guardando  = ref(false)
const error      = ref('')
const plan       = ref<PlanMejoramiento | null>(null)
const proceso    = ref<Proceso | null>(null)

const filtro = ref<'todas' | 'MEJORAMIENTO' | 'FORTALECIMIENTO'>('todas')
const filtros = [
  { id: 'todas',           label: 'Todas' },
  { id: 'MEJORAMIENTO',    label: 'Mejoramiento' },
  { id: 'FORTALECIMIENTO', label: 'Fortalecimiento' }
] as const

const tiposEntregable = [
  { clave: 'documento',            label: 'Documento' },
  { clave: 'listado',              label: 'Listado' },
  { clave: 'encuesta',             label: 'Encuesta' },
  { clave: 'estadistica',          label: 'Estadística' },
  { clave: 'registro_fotografico', label: 'Registro fotográfico' },
  { clave: 'video',                label: 'Video' },
  { clave: 'grupo_focal',          label: 'Grupo focal' },
  { clave: 'otro',                 label: 'Otro' }
] as const

// ── Configuración de columnas ─────────────────────────────────────────────────

type SeccionId = 'accion' | 'recursos' | 'seguimiento'

interface ColumnaConf   { clave: string; titulo: string; visible: boolean; seccion: SeccionId }
interface ColumnaExtra  { id: string; titulo: string; filas: Record<string, string>; seccion: SeccionId }
interface PlanColConfig { columnas: ColumnaConf[]; columnasExtra: ColumnaExtra[]; ordenGlobal: string[] }

const SECCIONES_UI = [
  { id: 'accion'      as SeccionId, label: 'Acción' },
  { id: 'recursos'    as SeccionId, label: 'Recursos y entregables' },
  { id: 'seguimiento' as SeccionId, label: 'Seguimiento' },
]

const COLS_DEFAULT: ColumnaConf[] = [
  { clave: 'factor',       titulo: 'Factor / Característica', visible: true, seccion: 'accion' },
  { clave: 'calificacion', titulo: 'Calif.',                  visible: true, seccion: 'accion' },
  { clave: 'tipo',         titulo: 'Tipo',                    visible: true, seccion: 'accion' },
  { clave: 'prioridad',    titulo: 'Prioridad',               visible: true, seccion: 'accion' },
  { clave: 'actividad',    titulo: 'Actividad general',       visible: true, seccion: 'accion' },
  { clave: 'responsable',  titulo: 'Responsable',             visible: true, seccion: 'accion' },
  { clave: 'terminacion',  titulo: 'Terminación',             visible: true, seccion: 'accion' },
  { clave: 'estado',       titulo: 'Estado',                  visible: true, seccion: 'seguimiento' },
  { clave: 'avance',       titulo: '% Avance',                visible: true, seccion: 'seguimiento' },
]

const COL_CONFIG_KEY = `plan-col-config-${idEjecucion}`

function cargarColConfig(): PlanColConfig {
  try {
    const raw = localStorage.getItem(COL_CONFIG_KEY)
    if (raw) {
      const saved = JSON.parse(raw) as Record<string, any>
      const merged: ColumnaConf[] = COLS_DEFAULT.map(def => {
        const found = (saved.columnas as any[] | undefined)?.find(c => c.clave === def.clave)
        return found
          ? { ...def, titulo: found.titulo ?? def.titulo, visible: found.visible ?? def.visible }
          : { ...def }
      })
      const extras: ColumnaExtra[] = ((saved.columnasExtra as any[]) ?? []).map((e: any) => ({
        id: e.id, titulo: e.titulo, filas: e.filas ?? {}, seccion: (e.seccion as SeccionId) ?? 'accion'
      }))
      let ordenGlobal: string[] = (saved.ordenGlobal as string[] | undefined) ?? []
      if (!ordenGlobal.length) {
        ordenGlobal = [...merged.map(c => c.clave), ...extras.map(e => e.id)]
      }
      const validKeys = new Set([...merged.map(c => c.clave), ...extras.map(e => e.id)])
      const clean = ordenGlobal.filter(k => validKeys.has(k))
      const missing = [...validKeys].filter(k => !clean.includes(k))
      return { columnas: merged, columnasExtra: extras, ordenGlobal: [...clean, ...missing] }
    }
  } catch (_e) { /* parse error — return defaults */ }
  const cols = COLS_DEFAULT.map(c => ({ ...c }))
  return { columnas: cols, columnasExtra: [], ordenGlobal: cols.map(c => c.clave) }
}

function guardarColConfig(): void {
  localStorage.setItem(COL_CONFIG_KEY, JSON.stringify(colConfig.value))
}

const colConfig = ref<PlanColConfig>(cargarColConfig())

interface ColEntry {
  key: string
  tipo: 'sistema' | 'extra'
  clave?: string
  extraCol?: ColumnaExtra
  titulo: string
  visible: boolean
  seccion: SeccionId
}

const columnasOrdenadas = computed<ColEntry[]>(() =>
  colConfig.value.ordenGlobal.map(key => {
    const sys = colConfig.value.columnas.find(c => c.clave === key)
    if (sys) return { key, tipo: 'sistema' as const, clave: sys.clave, titulo: sys.titulo, visible: sys.visible, seccion: sys.seccion }
    const ex = colConfig.value.columnasExtra.find(e => e.id === key)
    if (ex) return { key, tipo: 'extra' as const, extraCol: ex, titulo: ex.titulo, visible: true, seccion: ex.seccion }
    return null
  }).filter(Boolean) as ColEntry[]
)

// ── Modal configurar columnas ─────────────────────────────────────────────────

const configModal         = ref(false)
const configDraft         = ref<PlanColConfig>({ columnas: [], columnasExtra: [], ordenGlobal: [] })
const nuevoTituloColExtra = ref('')
const nuevaColSeccion     = ref<SeccionId>('accion')
const nuevaColPosicion    = ref<string>('ultimo')

watch(nuevaColSeccion, () => { nuevaColPosicion.value = 'ultimo' })

interface DraftItem {
  key: string
  tipo: 'sistema' | 'extra'
  data: ColumnaConf | ColumnaExtra
}

function getSeccionDeKeyDraft(key: string): SeccionId | null {
  const sys = configDraft.value.columnas.find(c => c.clave === key)
  if (sys) return sys.seccion
  const ex = configDraft.value.columnasExtra.find(e => e.id === key)
  if (ex) return ex.seccion
  return null
}

function draftSys(key: string): ColumnaConf {
  return configDraft.value.columnas.find(c => c.clave === key)!
}

function draftExtra(id: string): ColumnaExtra {
  return configDraft.value.columnasExtra.find(e => e.id === id)!
}

const configDraftGrupos = computed(() =>
  SECCIONES_UI.map(sec => ({
    ...sec,
    items: configDraft.value.ordenGlobal
      .filter(k => getSeccionDeKeyDraft(k) === sec.id)
      .map(k => {
        const sys = configDraft.value.columnas.find(c => c.clave === k)
        if (sys) return { key: k, tipo: 'sistema' as const, data: sys as ColumnaConf | ColumnaExtra }
        const ex = configDraft.value.columnasExtra.find(e => e.id === k)
        if (ex) return { key: k, tipo: 'extra' as const, data: ex as ColumnaConf | ColumnaExtra }
        return null
      })
      .filter(Boolean) as DraftItem[]
  }))
)

function abrirConfigColumnas(): void {
  configDraft.value = JSON.parse(JSON.stringify(colConfig.value))
  nuevoTituloColExtra.value = ''
  nuevaColSeccion.value = 'accion'
  nuevaColPosicion.value = 'ultimo'
  configModal.value = true
}

function agregarColExtra(): void {
  const titulo = nuevoTituloColExtra.value.trim()
  if (!titulo) return
  const id = crypto.randomUUID()
  const seccion = nuevaColSeccion.value
  const posicion = nuevaColPosicion.value
  const orden = configDraft.value.ordenGlobal
  // Compute insert position BEFORE adding to extras (so getSeccionDeKeyDraft doesn't see the new id yet)
  let insertPos: number
  if (posicion === 'ultimo') {
    const keysEnSec = orden.filter(k => getSeccionDeKeyDraft(k) === seccion)
    const lastKey = keysEnSec[keysEnSec.length - 1]
    insertPos = lastKey ? orden.indexOf(lastKey) + 1 : orden.length
  } else {
    insertPos = orden.indexOf(posicion) + 1
    if (insertPos === 0) insertPos = orden.length
  }
  configDraft.value.columnasExtra.push({ id, titulo, filas: {}, seccion })
  orden.splice(insertPos, 0, id)
  nuevoTituloColExtra.value = ''
  nuevaColPosicion.value = 'ultimo'
}

function eliminarColExtra(id: string): void {
  configDraft.value.columnasExtra = configDraft.value.columnasExtra.filter(c => c.id !== id)
  configDraft.value.ordenGlobal   = configDraft.value.ordenGlobal.filter(k => k !== id)
}

function moverEnSeccionDraft(seccion: SeccionId, key: string, dir: -1 | 1): void {
  const orden = configDraft.value.ordenGlobal
  const keysEnSec = orden.filter(k => getSeccionDeKeyDraft(k) === seccion)
  const idxEnSec = keysEnSec.indexOf(key)
  const idxDestino = idxEnSec + dir
  if (idxDestino < 0 || idxDestino >= keysEnSec.length) return
  const otroKey = keysEnSec[idxDestino]
  const posA = orden.indexOf(key)
  const posB = orden.indexOf(otroKey)
  orden[posA] = otroKey
  orden[posB] = key
}

function aplicarConfig(): void {
  const prevExtras = colConfig.value.columnasExtra
  const next = JSON.parse(JSON.stringify(configDraft.value)) as PlanColConfig
  for (const ec of next.columnasExtra) {
    const prev = prevExtras.find(p => p.id === ec.id)
    if (prev) ec.filas = { ...prev.filas }
  }
  colConfig.value = next
  guardarColConfig()
  configModal.value = false
}

// ── Modal de edición de acción ────────────────────────────────────────────────

const modal             = ref<AccionMejora | null>(null)
const pestana           = ref<'accion' | 'recursos' | 'seguimiento'>('accion')
const mensajeModal      = ref('')
const mensajeModalError = ref(false)
const form              = reactive<Partial<AccionMejora>>({})
const seg               = reactive<Partial<AccionMejora>>({})
const extraColValues    = reactive<Record<string, string>>({})

function extrasDeSeccion(seccion: SeccionId): ColumnaExtra[] {
  return columnasOrdenadas.value
    .filter(c => c.tipo === 'extra' && c.seccion === seccion)
    .map(c => c.extraCol!)
}

function cmpOrdinal(a: string | null | undefined, b: string | null | undefined): number {
  if (!a && !b) return 0
  if (!a) return 1
  if (!b) return -1
  const pa = a.split('.').map(Number)
  const pb = b.split('.').map(Number)
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0)
    if (d !== 0) return d
  }
  return 0
}

const accionesFiltradas = computed(() => {
  const acciones = plan.value?.acciones ?? []
  const filtradas = filtro.value === 'todas' ? acciones : acciones.filter(a => a.tipo === filtro.value)
  return [...filtradas].sort((a, b) => {
    const cP = cmpOrdinal(
      (a.componente?.padre as any)?.ordinal,
      (b.componente?.padre as any)?.ordinal
    )
    if (cP !== 0) return cP
    return cmpOrdinal(
      (a.componente as any)?.ordinal,
      (b.componente as any)?.ordinal
    )
  })
})

function contar(id: string): number {
  const acciones = plan.value?.acciones ?? []
  return id === 'todas' ? acciones.length : acciones.filter(a => a.tipo === id).length
}

function formatFecha(f: string | null | undefined): string {
  if (!f) return '—'
  const d = new Date(f)
  if (isNaN(d.getTime())) return f
  return d.toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric' })
}

function pillPrioridad(p: string | null): string {
  return p === 'ALTA' ? 'p-rojo' : p === 'MEDIA' ? 'p-ambar' : 'p-gris'
}

function pillEstado(e: string): string {
  return ({
    NO_INICIADO: 'p-naranja', EN_DESARROLLO: 'p-ambar', CUMPLIDO: 'p-verde',
    NO_CUMPLIDO: 'p-rojo',   ANULADO: 'p-azul'
  } as Record<string, string>)[e] ?? 'p-gris'
}

function abrirModal(a: AccionMejora): void {
  modal.value = a
  pestana.value = 'accion'
  mensajeModal.value = ''
  Object.assign(form, {
    causa_raiz: a.causa_raiz, actividad_general: a.actividad_general,
    actividades_especificas: a.actividades_especificas, tipo: a.tipo, prioridad: a.prioridad,
    responsable_cargo: a.responsable_cargo, fecha_inicio: a.fecha_inicio, fecha_terminacion: a.fecha_terminacion,
    recursos: { h: false, f: false, t: false, ...(a.recursos ?? {}) },
    presupuesto_proyectado: a.presupuesto_proyectado, presupuesto_ejecutado: a.presupuesto_ejecutado,
    entregables: { ...(a.entregables ?? {}) }, fuente_verificacion: a.fuente_verificacion, meta: a.meta,
    por_cumplir: a.por_cumplir
  })
  Object.assign(seg, {
    fecha_seguimiento: a.fecha_seguimiento, estado: a.estado, avance_pct: a.avance_pct,
    fecha_cierre: a.fecha_cierre, observaciones: a.observaciones
  })
  for (const ec of colConfig.value.columnasExtra) {
    extraColValues[ec.id] = ec.filas[String(a.id_accion)] ?? ''
  }
}

async function guardarModal(): Promise<void> {
  if (!modal.value) return
  guardando.value = true
  mensajeModal.value = ''

  const r = pestana.value === 'seguimiento'
    ? await registrarSeguimientoService(modal.value.id_accion, seg)
    : await actualizarAccionService(modal.value.id_accion, form)

  mensajeModalError.value = !r.ok
  mensajeModal.value = r.ok ? 'Guardado' : (r.error ?? 'Error al guardar')

  if (r.ok) {
    if (r.data && plan.value?.acciones) {
      const idx = plan.value.acciones.findIndex(x => x.id_accion === r.data!.id_accion)
      if (idx >= 0) plan.value.acciones[idx] = { ...plan.value.acciones[idx], ...r.data }
    }
    const idAccion = String(modal.value.id_accion)
    for (const ec of colConfig.value.columnasExtra) {
      ec.filas[idAccion] = extraColValues[ec.id] ?? ''
    }
    guardarColConfig()
  }

  guardando.value = false
}

async function generar(): Promise<void> {
  generando.value = true
  error.value = ''
  const r = await generarPlanService(idEjecucion)
  if (r.ok) await cargar()
  else error.value = r.error ?? 'No se pudo generar el plan'
  generando.value = false
}

async function exportar(): Promise<void> {
  if (!plan.value) return
  exportando.value = true
  const r = await getPlanExportService(plan.value.id_plan)
  if (r.ok && r.data) {
    const extrasOrdenados = columnasOrdenadas.value
      .filter(c => c.tipo === 'extra')
      .map(c => c.extraCol!)
    await exportarPlanInstitucional(r.data, extrasOrdenados)
  } else {
    error.value = r.error ?? 'No se pudo exportar'
  }
  exportando.value = false
}

async function cargar(): Promise<void> {
  const r = await getPlanService(idEjecucion)
  if (r.ok && r.data) {
    plan.value = r.data
  } else if (!r.ok && r.status !== 404) {
    error.value = r.error ?? 'No se pudo cargar el plan de mejoramiento'
  }
}

onMounted(async () => {
  const [proc] = await Promise.all([
    getProcesoByIdService(idEjecucion),
    cargar()
  ])
  proceso.value = proc
  cargando.value = false
})
</script>

<style scoped>
.plan-vista {
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin: 20px;
  padding: 20px 24px;
  box-sizing: border-box;
  font-family: inherit;
}

.ctx-modelo { display: inline-block; margin: 6px 0 0; padding: 3px 10px; background: #e8f0f8; border-left: 3px solid #0e69a0; border-radius: 3px; font-size: 0.85rem; font-weight: 700; color: #111; letter-spacing: 0.01em; }
.header-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}
.header-flex > div:first-child {
  flex-shrink: 1;
}
.titulo {
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0 0 0.2rem;
  color: #1a1a1a;
  white-space: nowrap;
}
.subtitulo {
  font-size: 0.82rem;
  color: #555;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.divider {
  border: none;
  border-bottom: 1px solid #e0e0e0;
  margin: 1rem 0;
}

.sin-plan-card {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 48px 40px;
  text-align: center;
  max-width: 520px;
  margin: 40px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.sin-plan-card h2 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #000;
  margin: 0;
}
.sin-plan-card p {
  font-size: 0.88rem;
  color: #555;
  line-height: 1.7;
  margin: 0;
  max-width: 420px;
}

.estado-plan {
  background: #e8f0fb;
  color: #0e69a0;
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.acciones-barra { display: flex; gap: 8px; flex-shrink: 0; align-items: center; }

.filtros-barra {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}
.filtros { display: flex; gap: 6px; flex-wrap: wrap; }
.tab {
  border: 1px solid #d0d0d0;
  background: #fff;
  border-radius: 6px;
  padding: 5px 12px;
  font-size: 0.8rem;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.15s;
}
.tab:hover:not(.activo) { border-color: #0e69a0; color: #0e69a0; }
.tab.activo { background: #0e69a0; border-color: #0e69a0; color: #fff; font-weight: 600; }

.btn-col-cfg {
  padding: 5px 14px;
  font-size: 0.8rem;
  font-weight: 600;
  border: 1px solid #b0d0e8;
  border-radius: 6px;
  background: #f0f7fd;
  color: #0e69a0;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.15s;
  white-space: nowrap;
  flex-shrink: 0;
}
.btn-col-cfg:hover { background: #daeaf8; border-color: #0e69a0; }

.contenedor-tabla { overflow-x: auto; }
.lista-tabla { width: 100%; border-collapse: collapse; font-size: 0.83rem; }
.lista-tabla th {
  background: #0e69a0;
  color: #fff;
  padding: 8px 10px;
  text-align: left;
  font-weight: 600;
  font-size: 0.8rem;
}
.th-extra { background: #1a56a0; }
.lista-tabla td { border-bottom: 1px solid #edf0f5; padding: 7px 10px; vertical-align: top; }
.lista-tabla tbody tr:hover { background: #f5f9fd; }
.num { text-align: right; }
.texto { max-width: 220px; }

.pill { padding: 2px 8px; border-radius: 9px; font-size: 0.72rem; font-weight: 600; white-space: nowrap; }
.p-verde   { background: #d9efe4; color: #0f6e56; }
.p-ambar   { background: #fdeecd; color: #854f0b; }
.p-rojo    { background: #fadddd; color: #a32d2d; }
.p-naranja { background: #fde4cd; color: #8a4a0b; }
.p-azul    { background: #dbe8f8; color: #185fa5; }
.p-gris    { background: #eee;    color: #555;    }

.btn {
  padding: 0 1.25rem;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  height: 36px;
  font-size: 0.83rem;
  font-family: inherit;
  transition: all 0.15s ease;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.btn:disabled { opacity: 0.5; cursor: not-allowed; }
.btn.guardar { background: #eea222; color: #000; }
.btn.guardar:hover:not(:disabled) { background: #0e69a0; color: #fff; }
.btn.accion { background: #0e69a0; color: #fff; }
.btn.accion:hover:not(:disabled) { background: #0b5580; }
.btn.salir { background: #fff; border: 1px solid #ccc; color: #333; }
.btn.salir:hover:not(:disabled) { border-color: #0e69a0; color: #0e69a0; }
.btn.mini { height: 28px; padding: 0 10px; font-size: 0.76rem; }

.mensaje { font-size: 0.85rem; color: #0f6e56; }
.mensaje.error { color: #a32d2d; }

.modal-fondo {
  position: fixed; inset: 0; background: rgba(0,0,0,0.4);
  display: flex; align-items: center; justify-content: center; z-index: 50;
}
.modal {
  background: #fff; border-radius: 10px; padding: 22px 26px;
  width: min(700px, 94vw); max-height: 88vh; overflow-y: auto;
  box-shadow: 0 8px 40px rgba(0,0,0,0.18);
}
.modal-titulo { font-size: 1rem; font-weight: 700; margin: 0 0 4px; color: #000; }
.linea-base { font-size: 0.8rem; color: #666; margin: 0 0 12px; }
.tabs { display: flex; gap: 6px; margin-bottom: 14px; flex-wrap: wrap; }
.form { display: grid; gap: 10px; }
.form label { display: block; font-size: 0.82rem; font-weight: 600; color: #333; }
.form input, .form textarea, .form select {
  display: block; width: 100%; margin-top: 3px; padding: 6px 8px;
  border: 1px solid #c9c9c9; border-radius: 6px; font-weight: 400;
  font-family: inherit; font-size: 0.85rem; transition: border-color 0.15s;
}
.form input:focus, .form textarea:focus, .form select:focus {
  outline: none; border-color: #0e69a0;
}
.fila { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
fieldset { border: 1px solid #e0e0e0; border-radius: 8px; padding: 8px 12px; }
legend { font-size: 0.8rem; font-weight: 600; padding: 0 4px; color: #444; }
.chk { display: inline-flex !important; align-items: center; gap: 4px; margin-right: 14px; font-weight: 400 !important; }
.chk input { width: auto !important; display: inline !important; margin-top: 0 !important; }
.form-divider { border: none; border-top: 1px dashed #ddd; margin: 4px 0; }
.modal-pie {
  display: flex; justify-content: flex-end; align-items: center;
  gap: 10px; margin-top: 16px; padding-top: 14px;
  border-top: 1px solid #ebebeb;
}

.modal-config { padding: 0; display: flex; flex-direction: column; max-height: 80vh; }
.cfg-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 20px; border-bottom: 1px solid #e0e0e0; flex-shrink: 0;
}
.cfg-header h3 { margin: 0; font-size: 1rem; font-weight: 700; color: #1a1a1a; }
.btn-cerrar {
  background: none; border: none; font-size: 1.1rem; cursor: pointer;
  color: #888; padding: 0; line-height: 1; transition: color 0.15s;
}
.btn-cerrar:hover { color: #dc3545; }
.cfg-body {
  padding: 16px 20px; overflow-y: auto; flex: 1;
  display: flex; flex-direction: column; gap: 1.25rem;
}
.cfg-seccion { display: flex; flex-direction: column; gap: 0.6rem; }
.cfg-seccion-titulo {
  font-size: 0.75rem; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.07em; color: #000; padding-bottom: 6px;
  border-bottom: 1px solid #e0e0e0;
}
.cfg-desc { font-size: 0.82rem; color: #666; margin: 0; }

.col-config-lista { display: flex; flex-direction: column; gap: 6px; }
.col-config-fila {
  display: flex; align-items: center; gap: 8px;
  padding: 6px 10px; border: 1px solid #e8e8e8; border-radius: 6px;
  background: #fafafa;
}
.col-es-extra { background: #eaf3fb !important; border-color: #c0d8ee !important; }
.col-toggle { display: flex; align-items: center; gap: 6px; flex-shrink: 0; cursor: pointer; }
.col-toggle input { accent-color: #0e69a0; width: 15px; height: 15px; cursor: pointer; }
.toggle-label { font-size: 0.76rem; font-weight: 600; color: #555; width: 50px; }
.col-toggle-spacer { display: inline-flex; flex-shrink: 0; width: 85px; }

.input-col-titulo {
  flex: 1; padding: 5px 9px; border: 1px solid #c0d4e8; border-radius: 5px;
  font-size: 0.85rem; font-weight: 600; font-family: inherit; background: white;
}
.input-col-titulo:disabled { opacity: 0.4; background: #f5f5f5; }
.input-col-titulo:not(:disabled):focus { outline: none; border-color: #0e69a0; }

.btn-mover {
  padding: 2px 7px; border: 1px solid #c0c0c0; border-radius: 4px;
  background: #f8f8f8; color: #555; font-size: 0.8rem; cursor: pointer;
  flex-shrink: 0; font-family: inherit; line-height: 1.5; transition: all 0.12s;
}
.btn-mover:hover:not(:disabled) { background: #e4eef8; border-color: #0e69a0; color: #0e69a0; }
.btn-mover:disabled { opacity: 0.3; cursor: not-allowed; }

.btn-elim-col {
  padding: 4px 10px; border: 1px solid #dc3545; border-radius: 5px;
  background: white; color: #dc3545; font-size: 0.75rem; font-weight: 600;
  cursor: pointer; font-family: inherit; flex-shrink: 0; transition: all 0.15s;
  white-space: nowrap;
}
.btn-elim-col:hover { background: #dc3545; color: white; }

.sin-extra { font-size: 0.82rem; color: #aaa; font-style: italic; margin: 0; }

.nueva-col-form-v2 { display: flex; flex-direction: column; gap: 10px; }
.input-col {
  padding: 6px 10px; border: 1px solid #ccc; border-radius: 6px;
  font-size: 0.85rem; font-family: inherit; width: 100%; box-sizing: border-box;
}
.input-col:focus { outline: none; border-color: #0e69a0; }
.seccion-radio-row { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }
.seccion-label { font-size: 0.8rem; font-weight: 600; color: #555; white-space: nowrap; }
.seccion-radio { display: inline-flex; align-items: center; gap: 4px; font-size: 0.82rem; cursor: pointer; }
.seccion-radio input { accent-color: #0e69a0; width: 14px; height: 14px; margin: 0; cursor: pointer; }
.posicion-row { display: flex; align-items: center; gap: 10px; }
.select-posicion {
  flex: 1; padding: 6px 8px; border: 1px solid #ccc; border-radius: 6px;
  font-size: 0.82rem; font-family: inherit;
}
.select-posicion:focus { outline: none; border-color: #0e69a0; }
.btn-add-col {
  align-self: flex-start; padding: 6px 14px; border: 1px solid #0e69a0; border-radius: 6px;
  background: #0e69a0; color: white; font-weight: 600; font-size: 0.82rem;
  cursor: pointer; font-family: inherit; transition: background 0.15s;
}
.btn-add-col:disabled { opacity: 0.4; cursor: not-allowed; }
.btn-add-col:hover:not(:disabled) { background: #0b5580; }

.modal-config .modal-pie {
  padding: 12px 20px; margin: 0; border-top: 1px solid #e0e0e0;
  flex-shrink: 0;
}
</style>
